import lazyLoading from './lazyLoading'

export default {
  name: 'tripsBasic',
  meta: {
    expanded: false,
    title: 'Viajes',
    iconClass: 'fa fa-taxi'
  },
  children: [
    {
      path: '/trips/trip-finished',
      component: lazyLoading('trips/Main'),
      meta: {
        title: 'Viajes',
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('trips/Finished'),
          meta: {
            title: 'Finalizado',
          }
        },
        {
          name: 'tripView',
          path: ':travelId',
          component: lazyLoading('trips/View'),
          props: true,
          meta: {
            title: 'Finalizado',
          }
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/tripsBasic.js